import { Modal, Button } from "react-bootstrap";

const DeleteLeadStage = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop={false} centered>
      <Modal.Body className="text-center">
        <h5>Are you sure?</h5>
        <p>Delete this stage?</p>

        <div className="footer-actions">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger">Delete</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteLeadStage;
